import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export const PopoverContent = React.forwardRef(({children, ...props}, forwardedRef) => (
  <PopoverPrimitive.Content sideOffset={5} {...props} ref={forwardedRef}>
    {children}
    {props.useArrow && <PopoverPrimitive.Arrow />}
  </PopoverPrimitive.Content>
));
